import clsx from 'clsx'
import { Text } from '../../../../../ui'
import { useEffect, useState } from 'react'
import { formatCurrency, formatDate, formatRut } from '../../../../../../utils/formatter'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import translations from '../../../../../ui/traslation/traslationAdministracion.json'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import isologo_SII from '../../../../../../../assets/isologo_SII.png'
import iconNuevo from '../../../../../../../assets/iconos/iconNuevo.png'
import iconVinculos from '../../../../../../../assets/iconosCardInformes/informe_9.png'
import iconPrevired from '../../../../../../../assets/iconosBancos/previred-logo.png'
import { VinculacionIcon } from '../../Vinculaciones/IconosPlantilla'
import {
  getMovementDisplayAmount,
  getMovementRelationDate,
//   getMovementAssignedAmount,
//   getMovementPaymentStatus,
  isBoletaHonorarios,
  isVinculacionRow,
  mergeUniqueMovements
} from './respaldo.utils'
import { getCurrentDate } from '../../../../../../utils/constant'
import { getFolioCreditoLabel } from '../data'

const TablaBancoCreate = ({onCheckboxChange,rows,dataLinkage,onSort,order,onInitialSelectedIds,onCurrentSelectedIdsChange,rowsPerPage,
  dataModal,onCurrentData,selectedCheckboxes,setSelectedCheckboxes,onCurrentRealIdsChange}) => {
  const [page] = useState(0)
  const [currentDate] = useState(getCurrentDate())

useEffect(() => {
    if (!Array.isArray(rows) || rows.length === 0) return

    const initial = {}
    rows.forEach(item => {
      initial[item.id] = item.seleccionado || false
    })

    setSelectedCheckboxes(prev => ({
      ...initial,
      ...prev, 
    }))
  }, [JSON.stringify(rows.map(r => r.id)), JSON.stringify(dataLinkage)])

  useEffect(() => {
  if (!Array.isArray(rows)) return

  const selectedRows = Object.entries(selectedCheckboxes)
    .filter(([_, isChecked]) => isChecked)
    .map(([key]) => rows.find(r => r?.id === Number(key)))
    .filter(Boolean)

  const selectedIds = selectedRows.map(r => r.id)
  const selectedRealIds = selectedRows.map(r => r.idPrincipal ?? r.id)

  onCurrentSelectedIdsChange?.(selectedIds)
  onCurrentRealIdsChange?.(selectedRealIds)
  onCurrentData?.(selectedRows)
}, [JSON.stringify(selectedCheckboxes), JSON.stringify(rows)])

  const handleCheckboxToggle = id => {
    setSelectedCheckboxes(prev => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  const styles = {
    wrapper: 'overflow-x-auto rounded-3xl shadow-sm',
    table: 'w-full table-auto text-[0.725rem] border-collapse leading-tight',
    thead: 'sticky top-0 z-10 bg-gray-50',
    th: 'py-2 px-1 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
    td: 'py-2 px-2 max-w-[200px] text-center align-middle truncate',
    smallCol: 'w-auto max-w-[80px]',
    amountCol: 'min-w-[125px] whitespace-nowrap',
    statusCol: 'w-[1%] whitespace-nowrap',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.65rem]',
    text: 'text-[0.705rem] text-gray-400 font-sans font-medium',
  }

  const getSaldoColTitle = () => {
    const selectedRows = rows.filter(r => selectedCheckboxes[r.id])
    if (selectedRows.length > 0 || dataModal?.linkage?.length > 0) {
      const tipo = dataModal?.categoriaTipoMovimiento
      if (tipo === 'abono') return 'Disponible'
      if (tipo === 'cargo') return 'Disponible'
    } else {
      const tipo = dataModal?.categoriaTipoMovimiento
      if (tipo === 'abono') return 'Disponible'
      if (tipo === 'cargo') return 'Disponible'
    }
    return 'Saldo por Asignar'
  }

  const orderableCols = [
    { col: '', field: null },
    { col: 'Documento', field: 'documento' },
    { col: 'Cliente', field: 'cliente' },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Monto', field: 'monto' },
    { col: getSaldoColTitle(), field: 'saldoAsignar' },
    //{ col: 'Status', field: 'status' },
    { col: 'Acciones', field: 'acciones' }
  ]

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0

  const obtenerAbreviatura = nombre => translations.documentosContables[nombre] || nombre
  const getNombreFolio = item => {
    return getFolioCreditoLabel(item) || String(item?.nombreFolio || '').trim()
  }

// La API y dataModal.linkage pueden representar el mismo movimiento usando
// `id` o `idPrincipal`; se conserva una sola fila si cualquiera coincide.
const uniqueRows = mergeUniqueMovements(rows)

//   const normalizeStatus = status =>
//       String(status || '')
//         .replace(/\s*undefined\s*/gi, '')
//         .trim()
//         .toUpperCase()
//
//   const statusTone = status => {
//     const s = normalizeStatus(status)
//     if (s.includes('PARCIAL')) return 'warning'
//     if (s.includes('PAGADO') || s.includes('COBRADO') || s.includes('CONCILIADO')) return 'success'
//     if (s.includes('POR PAGAR') || s.includes('POR COBRAR')) return 'danger'
//     return 'muted'
//   }
//
//     const statusBadgeClass = status => {
//       const tone = statusTone(status)
//       return clsx(
//         'inline-flex items-center justify-center px-3 py-1 rounded-full text-[0.6rem] sm:text-[0.65rem] font-semibold uppercase tracking-wider',
//         'whitespace-nowrap',
//         {
//           'text-danger bg-danger/10': tone === 'danger',
//           'text-success bg-success/10': tone === 'success',
//           'text-amber-700 bg-amber-100': tone === 'warning',
//           'text-muted bg-border/40': tone === 'muted'
//         }
//       )
//     }
//
    const truncateText = (text, max = 15) => {
  if (!text) return ''
  return text.length > max ? text.slice(0, max) + '...' : text
}

  return (
    <div className={styles.wrapper}>
        <div className='mt-2 h-auto font-medium'>
        <table className={styles.table}>
          <thead className={styles.thead}>
            <tr>
              {orderableCols.map(({ col, field }, i) => (
                <th
                  className={clsx(
                    styles.th,
                    { 'cursor-pointer': field },
                    i === 0 && styles.smallCol,
                    field === 'monto' && styles.amountCol,
                    field === 'status' && styles.statusCol
                  )}
                  onClick={() => field && onSort({ col, field })}
                  key={i}
                >
                  {col}
                  {order.col === col && (
                    <KeyboardArrowDownIcon
                      className={clsx('transition-all ml-2 cursor-pointer', {
                        'opacity-40': order.col !== col,
                        'rotate-180': order.direction === 'desc'
                      })}
                    />
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className={styles.tbody}>
            {uniqueRows.map((item, i) => {
              const isChecked = !!selectedCheckboxes[item.id]
              const esBoleta = isBoletaHonorarios(item)
              const origenTabla = Number(item.origenTabla)
              const esMovimientoRemuneracion = [29, 30].includes(origenTabla)
              const soloMontoTotal = origenTabla === 39 || esMovimientoRemuneracion
//               const displayStatus = getMovementPaymentStatus(item, dataModal)
              const nombreFolio = getNombreFolio(item)
              const nombreFolioMostrar = obtenerAbreviatura(nombreFolio)
              return (
                <tr key={item.id} className={styles.tr}>
                  <td className={clsx(styles.td, styles.smallCol)}>
                    <div className='flex items-center justify-center min-h-[64px]'>
                      {/* Checkbox */}
                      <input
                        type='checkbox'
                        className='rounded'
                        checked={isChecked}
                        onChange={() => handleCheckboxToggle(item.id)}
                      />

                      {/* Contenedor de la imagen con altura fija */}
                      <div className='relative flex-shrink-0 h-14 w-14 flex items-center justify-center'>
                        {isVinculacionRow(item) ? (
                          <VinculacionIcon item={item} />
                        ) : ([item.nombreOrigen, item.origen]
                          .some(value => value?.trim().toLowerCase() === 'sii') ||
                          origenTabla === 39) ? (
                          <img src={isologo_SII} className='max-h-5 max-w-5' />
                        ) : (item.razonSocial?.trim().toLowerCase() === 'previred' || origenTabla === 30) ? (
                          <img src={iconPrevired} className='max-h-full max-w-full' />
                        ) : (
                          <img src={iconVinculos} className='max-h-10 max-w-10' />
                        )}

                        {currentDate === formatDate(rows.fecha) && (
                          <img
                            src={iconNuevo}
                            className='absolute -top-2 left-4 w-4 h-4 opacity-60'
                          />
                        )}
                      </div>
                    </div>
                  </td>

                  {/* Folio */}
                  <td className={clsx(styles.td, styles.smallCol)}>
                    <Text
                      className={clsx(styles.boldText, 'truncate')}
                      title={nombreFolio}
                    >
                      {truncateText(nombreFolioMostrar, 15)}
                    </Text>
                    <Text className={styles.text}>{item.numeroFolio}</Text>
                  </td>
                  {/* Cliente (con más ancho) */}
                  <td className={clsx(styles.td, styles.mediumCol)}>
                    {(() => {
                      const sourceText = item.glosa || item.descripcion || ''
                      const f29Match = sourceText.match(/f29\s*-\s*(.+)$/i)
                      const monthMatch = sourceText.match(/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|setiembre|octubre|noviembre|diciembre)\b/i)
                      const getLabelWithMonth = (label) =>
                        monthMatch?.[1]
                          ? `${monthMatch[1].charAt(0).toUpperCase()}${monthMatch[1].slice(1).toLowerCase()} - ${label}`
                          : label
                      const nombreMostrar =
                        origenTabla === 30
                          ? getLabelWithMonth('PreviRed')
                          : origenTabla === 39
                            ? (
                                f29Match?.[1]
                                  ? `F29 - ${f29Match[1].trim().toLowerCase()}`
                                  : 'F29'
                              )
                          : origenTabla === 29
                            ? getLabelWithMonth('Monto Líquido')
                            : (
                                item.razonSocial
                                  ? item.razonSocial.charAt(0).toUpperCase() +
                                    item.razonSocial.slice(1)?.toLowerCase()
                                  : item.glosa || '<Sin Razón Social>'
                              )

                      return (
                        <>
                          <Text className={clsx(styles.boldText, 'truncate')} title={nombreMostrar} > {truncateText(nombreMostrar, 15)}</Text>
                          <Text className={clsx(styles.text)} >{item.rut || formatRut(item.rut) || '<RUT>'} </Text>
                        </>
                      )
                    })()}
                  </td>
                  {/* Fecha */}
                  <td className={clsx(styles.td, styles.smallCol)}>
                    <Text className={styles.boldText}>{formatDate(getMovementRelationDate(item, dataLinkage ?? dataModal?.linkage ?? []))}</Text>
                    <Text className={styles.text}>
                      {item.fechaVencimiento && formatDate(item.fechaVencimiento)}
                    </Text>
                  </td>
                  {/* Clasificación 
                  <td className={clsx(styles.td, styles.mediumCol)}>
                    <Text className={clsx(styles.boldText, 'truncate')}  title={item.nombreCuenta}>{truncateText(item.nombreCuenta)}</Text>
                    <Text className='text-[10px] text-gray-500 leading-tight'>
                      {item.codigoCuenta}
                    </Text>
                    <Text className='text-[10px] text-gray-500 leading-tight'>
                      {item.comprobante}
                    </Text>
                  </td>*/}
                  {/* Monto */}
                  <td className={clsx(styles.td, styles.amountCol)}>
                    {soloMontoTotal ? (
                      <Text className={clsx(styles.boldText, 'text-right font-bold')}>
                        {formatCurrency(item.montoTotal)}
                      </Text>
                    ) : esBoleta ? (
                      <>
                        <Text className={clsx(styles.boldText, 'text-right font-bold')}>
                          {formatCurrency(getMovementDisplayAmount(item))}
                        </Text>
                          <Text className='text-[10px] text-right text-accent3 leading-tight'>
                            Retención: {formatCurrency(item.montoIvaRetenido)}
                          </Text>
                        <Text className='text-[10px] text-right text-gray-500 leading-tight'>
                          Total Honorario: {formatCurrency(item.montoTotal)}
                        </Text>
                      </>
                    ) : (
                      <>
                        <Text className={clsx(styles.boldText, 'text-right font-bold')}>
                          {formatCurrency(item.montoTotal)}
                        </Text>
                          <Text className='text-[10px] text-right text-accent3 leading-tight'>
                            IVA: {formatCurrency(item.montoIvaRetenido)}
                          </Text>
                          <Text className='text-[10px] text-right text-gray-500 leading-tight'>
                            Neto: {formatCurrency(item.montoNetoLiquido)}
                          </Text>
                          <Text className='text-[10px] text-right text-gray-500 leading-tight'>
                            Exento: {formatCurrency(item.montoExento)}
                          </Text>
                      </>
                    )}
                  </td>
                  {/* SaldoAsignar */}
                  <td className={clsx(styles.td, styles.smallCol)}>
                    <Text className={clsx(styles.boldText, 'font-bold')}>
                      {formatCurrency(item.auxiliar)}
                    </Text>
                  </td>
                  {/* Status 
                  <td className={clsx(styles.td, styles.statusCol)}>
                    <span className={statusBadgeClass(displayStatus)}>
                    {displayStatus || '—'}
                  </span>
                  </td>*/}
                  {/* Acciones*/}
                  <td className={clsx(styles.td, styles.smallCol)}>
                    <div className='flex h-full items-center justify-center space-x-3'>
                      <div className='flex flex-col text-xs text-gray-500 items-center justify-center hover:cursor-pointer'>
                        <button
                          className={clsx(
                            'flex items-center justify-center w-7 h-7 rounded-full shadow-full-xs transition-colors duration-150',
                            {
                              'bg-accent2 text-white hover:bg-accent2/90 cursor-pointer': isChecked,
                              'bg-gray-100 text-gray-300 hover:bg-gray-200 cursor-pointer':
                                !isChecked
                            }
                          )}
                          onClick={() => handleCheckboxToggle(item.id)}
                        >
                          <DoneAllIcon className='w-4 h-4' />
                        </button>
                        <Text className='mt-2'>{isChecked ? 'Seleccionado' : 'Seleccionar'}</Text>
                      </div>
                    </div>
                  </td>
                </tr>
              )
            })}
            {emptyRows > 0 && (
              <tr className={styles.tr} style={{ height: 89 * emptyRows }}>
                <td className={styles.td} aria-hidden />
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TablaBancoCreate
